<template>
  <div :class="$options.name">
    <slot />
  </div>
</template>
<script lang="ts">
import { Arrays, lateinit, typed } from 'tg-commons'
import type { MarkerClusterer, MarkerClustererOptions, MarkerOverlay } from 'tg-map-core'
import { defineComponent } from 'vue'
import { type Props, optionalProp } from '../../utils/vue-utils'
import MapMixin from '../map-mixin'
const TgMarkerClusterer = defineComponent({
  name: 'tg-marker-clusterer',
  mixins: [MapMixin],
  // markers从this.$children中读取, 故需要省略(Omit)
  props: {
    gridSize: optionalProp(Number),
    maxZoom: optionalProp(Number),
    minClusterSize: optionalProp(Number),
    averageCenter: optionalProp(Boolean),
    styles: optionalProp(Array as any),
    stylesIndexCalculator: optionalProp(Function as any),
    zIndex: optionalProp(Number),
  } satisfies Props<Omit<MarkerClustererOptions, 'markers'>>,
  setup() {
    return {
      clusterer: lateinit<MarkerClusterer>(),
      markers: typed<MarkerOverlay[]>([]),
      pendingMarkers: typed<MarkerOverlay[]>([]),
    }
  },
  watch: {
    gridSize() {
      this.recreate()
    },
    maxZoom() {
      this.recreate()
    },
    minClusterSize() {
      this.recreate()
    },
    averageCenter() {
      this.recreate()
    },
    styles: {
      handler() {
        this.recreate()
      },
      deep: true,
    },
    stylesIndexCalculator() {
      this.recreate()
    },
    zIndex() {
      this.recreate()
    },
  },
  onCreate() {
    // console.log('TgMarkerClusterer.onCreate', this.markers)
    this.clusterer = this.$map.createMarkerClusterer(this)
  },
  onDestroy() {
    this.clusterer.clearMarkers(true)
    // 清空等待添加的markers
    this.pendingMarkers = []
  },
  methods: {
    /** TgMarker有可能在该组件未初始化之前调用, 需要通过该方法判断 */
    isInitiated(): boolean {
      return this.clusterer != null
    },
    performAddMarkers() {
      this.clusterer.addMarkers(this.pendingMarkers)
      this.pendingMarkers = []
    },
    onAddMarker(marker: MarkerOverlay) {
      this.markers.push(marker)
      if (this.isInitiated()) {
        if (!this.pendingMarkers.length) {
          this.$nextTick(this.performAddMarkers)
        }
        this.pendingMarkers.push(marker)
      }
    },
    onRemoveMarker(marker: MarkerOverlay) {
      if (this.isInitiated()) {
        if (!Arrays.remove(this.pendingMarkers, marker)) {
          this.clusterer.removeMarker(marker)
        }
      }
      Arrays.remove(this.markers, marker)
    },
  },
})
/** TgMarkerClusterer作为构造器, 创建的Vue实例类型 */
type TgMarkerClusterer = InstanceType<typeof TgMarkerClusterer>
export default TgMarkerClusterer
</script>
